import { Box } from '@mui/material';
import { useFormik } from 'formik';
import React, { ChangeEvent, FC, useCallback, useEffect, useRef, useState } from 'react';
import { AuthInitialFormValues } from '../../common/commonTypes';
// import { getError } from '../../common/components/AuthForm/AuthForm.helper';
import { DeactivatedUserModal } from '../../common/components/DeactivatedUserModal/DeactivatedUserModal';
import { ExistingUserModal } from '../../common/components/ExistingUserModal/ExistingUserModal';
import { PhoneFieldInternational } from '../../common/components/FormComponents/PhoneFieldInternational/PhoneFieldInternational';
import { UploadProgressBar } from '../../common/components/UploadProgressBar/UploadProgressBar';
import { authFormInitialValues, EventNames } from '../../common/constants/constants';
import { SignUpScreenStrings } from '../../common/localization/en';
import { useQuery } from '../../services/hooks/useQuery';
import { LoginWithPhoneNumber, requestMergeUser, resetMeError, updateUserRequest } from '../../store/slices/me';
import { setIsUploadComplete, setPendingUploadedStory } from '../../store/slices/upload';
import { useAppDispatch, useTypedSelector } from '../../store/store';
import { getValidationSchema } from '../MagicLinkPage/MagicLinkForm/MagicLinkForm.helper';
import {
  StyledContainer,
  ProgressBar,
  StyledForm,
  StyledInput,
  AuthSubmitBtn,
  StyledTextField,
  CaptchaWrapper,
} from './VerificationScreen.styles';
import { ReCaptcha, ReCaptchaRefType } from '../../common/components/FormComponents/ReCAPTCHA/ReCaptcha';
// import { CampaignTypes } from '../../api/models/rewards';
import { useTrackEvent } from '../../common/hooks/useTrackEvent';
import { PortalWrapper } from '../../common/components/PortalWrapper/PortalWrapper';

export const BottomPercent = '35%';

interface VerificationScreenProps {
  captchaResponse?: string;
}

const VerificationScreen: FC<VerificationScreenProps> = ({}) => {
  const queries = useQuery();
  const dispatch = useAppDispatch();
  const { account } = useTypedSelector((state) => state.account);
  const { isUploadInprogress, uploadingProgress } = useTypedSelector((state) => state.upload);
  // const { currentCampaign, primaryCampaign } = useTypedSelector((state) => state.rewards);

  // const isCustomRewardCampaign = currentCampaign?.campaignType === CampaignTypes.CUSTOM_REWARD;
  // const isMonthlyGiveawayCampaign = currentCampaign?.campaignType === CampaignTypes.MONTHLY_GIVEAWAY;
  // const isNoRewardCampaign = currentCampaign?.campaignType === CampaignTypes.NO_REWARD;

  const {
    account: { id: accountId },
  } = useTypedSelector((state) => state.account);
  const {
    registerErrorType,
    phoneNumber: mePhoneNumber,
    id,
    firstName: storeFirstName,
    lastName: storeLastName,
    phoneNumber: storePhoneNumber,
  } = useTypedSelector((state) => state.me);
  const { email, firstName, phoneNumber, lastName } = {
    email: queries.get('svIdent') || '',
    firstName: queries.get('svUn')?.split(' ')[0] || storeFirstName || '',
    lastName: queries.get('svUn')?.split(' ')[1] || storeLastName || '',
    phoneNumber: queries.get('phone') || mePhoneNumber || '',
  };

  const { trackEvent } = useTrackEvent();

  const [disabledSubmitButton, setDisabledSubmitButton] = useState(false);
  const [isDeactivatedUserModalOpen, setIsDeactivatedUserModalOpen] = useState(false);
  const [isExistingUserModalOpen, setIsExistingUserModalOpen] = useState(false);
  const [hideTopBanner, setHideTopBanner] = useState(false);

  const [isVerificationComplete, setIsverificationComplete] = useState(!!storePhoneNumber || false);

  const [captcha, setCaptcha] = useState<string | null>('');
  const [isEnterpriseCaptcha, setIsEnterpriseCaptcha] = useState(true);
  const ecaptchaRef = useRef<ReCaptchaRefType>(null);

  const showCompleteScreen = !isUploadInprogress && uploadingProgress === 100;

  useEffect(() => {
    if (showCompleteScreen) {
      const timeout = setTimeout(() => {
        setHideTopBanner(true);
        dispatch(setIsUploadComplete(true));
      }, 5000);
      return () => {
        clearTimeout(timeout);
      };
    }
  }, [showCompleteScreen]);

  // const validateEmail = currentCampaign ? !!currentCampaign?.emailRequired : !!primaryCampaign?.emailRequired;

  const initValues: AuthInitialFormValues = {
    ...authFormInitialValues,
    email,
    firstName,
    lastName,
    phoneNumber: mePhoneNumber,
  };

  const formikProps = {
    initialValues: initValues,
    validateOnChange: true,
    validateOnBlur: true,
    validationSchema: getValidationSchema({
      phoneNumber: true,
      firstName: false,
      lastName: false,
      email: false,
      // email: validateEmail,
    }),
    onSubmit: async (values: AuthInitialFormValues) => {
      localStorage.setItem('hideInfoBlock', 'true');
      trackEvent({ action: EventNames.next_button_click });
      await onSubmitHandler(values);
    },

    onReset: () => {
      setDisabledSubmitButton(false);
    },
  };

  const formik = useFormik({
    ...formikProps,
    validationSchema: getValidationSchema({
      phoneNumber: true,
      firstName: false,
      lastName: false,
      email: false,
      // email: validateEmail,
    }),
  });
  const fullName =
    formik.values.firstName && formik.values.lastName
      ? `${formik.values.firstName} ${formik.values.lastName}`
      : formik.values.firstName || '';

  const onSubmitHandler = useCallback(
    async (values: AuthInitialFormValues) => {
      const enterpriseCaptchaResponse = isEnterpriseCaptcha ? await ecaptchaRef.current?.executeAsync() : null;
      const captchaResponse = enterpriseCaptchaResponse || captcha || '';
      const magicLinkQueryParams = {
        accountId,
        isEnterpriseCaptcha: isEnterpriseCaptcha,
        phoneNumber: values.phoneNumber || phoneNumber,
        captchaResponse: captchaResponse,
        details: {
          // email: validateEmail ? values.email : null,
          email: null,
          firstName: values.firstName,
          lastName: values.lastName,
        },
      };

      setDisabledSubmitButton(true);

      dispatch(resetMeError());

      const isNewUserFlow = id !== '';
      const resultType = isNewUserFlow
        ? ((
            await dispatch(
              updateUserRequest({
                phoneNumber: values.phoneNumber,
                // email: email || (validateEmail ? values.email : null),
                email: email || null,
                userId: id,
                firstName: values.firstName,
                lastName: values.lastName,
              }),
            )
          ).type as string)
        : null;

      const isPhoneAlreadyExists = resultType && resultType.includes('rejected');
      const isUpdateSuccess = resultType && resultType.includes('fulfilled');

      if (isUpdateSuccess) {
        setIsverificationComplete(true);
        return;
      }

      if (!isPhoneAlreadyExists) {
        dispatch(setPendingUploadedStory(null));
      }
      let token = '';
      let userId = '';
      if (isPhoneAlreadyExists) {
        token = localStorage.getItem('authToken') || '';
        userId = id;
      }

      dispatch(LoginWithPhoneNumber(magicLinkQueryParams)).then((response: any) => {
        if (isPhoneAlreadyExists) {
          const id = response?.payload?.user?.id;
          dispatch(
            requestMergeUser({
              //@ts-ignore
              id: id || '',
              accessToken: token || '',
              userToMerge: userId,
            }),
          );
        }
      });

      // : await requestSignInVerificationCode(magicLinkQueryParams);
    },
    [accountId, phoneNumber, firstName, lastName, dispatch, id, email],
  );

  useEffect(() => {
    trackEvent({
      action: EventNames.Phone_Verification_Page,
      location: window.location.href,
      accountId: account.id,
      userId: id,
    });
  }, [account.id, id]);

  useEffect(() => {
    if (registerErrorType === 'userAlreadyExists') {
      setIsExistingUserModalOpen(true);
      dispatch(resetMeError());
    }
  }, [dispatch, registerErrorType]);

  const handlePhoneChange = (val: string) => {
    formik.setFieldValue('phoneNumber', '+' + val);
  };

  const handleTrackPhoneNumberBlur = () => {
    trackEvent({
      action: EventNames.Signup_Phone_Typed,
      location: window.location.href,
      accountId: account.id,
      phoneNumber: formik.values.phoneNumber,
      firstName: formik.values.firstName,
      lastName: formik.values.lastName,
      email: formik.values.email,
      form: 'verification_screen',
    });
    trackEvent({ action: EventNames.input_field_focus, name: 'phoneNumber', value: formik.values.phoneNumber });
  };

  const trackCountryCodeChange = () => {
    trackEvent({
      action: EventNames.Phone_Country_Select,
      location: window.location.href,
      accountId: account.id,
      firstName: formik.values.firstName,
      lastName: formik.values.lastName,
      email: formik.values.email,
      phoneNumber: formik.values.phoneNumber,
      form: 'verification_screen',
    });
  };

  const handleFieldChange = (event: ChangeEvent<HTMLInputElement>) => {
    formik.setFieldTouched(event.target.name);
    formik.handleChange(event);
  };

  // const getErrorHandler = (name: string, disabled?: boolean) => {
  //   if (disabled) {
  //     return formik.values[name] ? formik.errors[name] : '';
  //   }
  //   return getError(name, formik.touched, formik.errors);
  // };

  const sendVerificationCodeBtnDisabled =
    disabledSubmitButton || formik.isSubmitting || !!formik.errors.phoneNumber || !formik.dirty || !!formik.errors.email;

  const onCaptchaChange = (value: string | null) => {
    setCaptcha(value);

    if (!value) {
      setIsEnterpriseCaptcha(false);
    }
  };
  const handleBlur = (e: { target: { value: string; name: string } }) => {
    trackEvent({ action: EventNames.input_field_focus, name: e.target.name, value: e.target.value });
    formik.handleBlur(e);
  };

  return (
    <Box>
      <StyledContainer>
        <ProgressBar $fadeOut={hideTopBanner}>
          <UploadProgressBar />
        </ProgressBar>

        <DeactivatedUserModal
          isOpen={isDeactivatedUserModalOpen}
          onClose={() => {
            setIsDeactivatedUserModalOpen(false);
          }}
        />
        {/* <VerificationModal
          modalType={modal}
          phoneNumber={formik.values.phoneNumber}
          setModalType={setModal}
          codeId={codeId}
          onBackClick={() => {}}
          accountId={accountId}
        /> */}
        <ExistingUserModal
          isOpen={isExistingUserModalOpen}
          onClose={() => setIsExistingUserModalOpen(false)}
          phoneNumber={formik.values.phoneNumber}
          goToSignup={() => {}}
          trackProperties={{ accountId, phoneNumber, name: fullName, email }}
        />
        {!isVerificationComplete && (
          <PortalWrapper>
            <StyledForm onSubmit={formik.handleSubmit}>
              <>
                <p
                  style={{
                    fontWeight: '600',
                    color: '#4F49E1',
                    fontSize: 'clamp(13px,4.2vw,18px)',
                    whiteSpace: 'nowrap',
                    // margin: '5px',
                    lineHeight: '24px',
                  }}
                >
                  {SignUpScreenStrings.GetCredit}
                </p>
              </>

              <Box display={'flex'} gap="10px">
                <StyledInput
                  value={formik.values.firstName}
                  onChange={handleFieldChange}
                  disableUnderline={true}
                  name="firstName"
                  placeholder={SignUpScreenStrings.First}
                  onBlur={handleBlur}
                />

                <StyledInput
                  value={formik.values.lastName}
                  onChange={handleFieldChange}
                  disableUnderline={true}
                  name="lastName"
                  placeholder={SignUpScreenStrings.Last}
                  onBlur={handleBlur}
                />
              </Box>
              <StyledTextField>
                <PhoneFieldInternational
                  onChange={handlePhoneChange}
                  name="phoneNumber"
                  value={formik.values.phoneNumber || ''}
                  error={formik.errors.phoneNumber}
                  placeholder={'Enter Cell Number'}
                  showErrorOnBlur={true}
                  setTouched={() => {
                    formik.setFieldTouched('phoneNumber', true);
                    handleTrackPhoneNumberBlur();
                  }}
                  trackCountryCodeChange={trackCountryCodeChange}
                  isOutlinedForLightTheme={false}
                  inputFontSize="clamp(16px, 4.4vw, 24px)"
                />
              </StyledTextField>
              {/* {validateEmail && (
                <Box style={{ marginTop: '10px' }}>
                  <Input
                    className={styles.input}
                    value={formik.values.email}
                    onChange={handleFieldChange}
                    disableUnderline={true}
                    error={!!getErrorHandler('email', true)}
                    name="email"
                    placeholder={'Enter an email'}
                    onBlur={handleBlur}
                  />
                  {getErrorHandler('email', true) && (
                    <Typography className={styles.errorText}>{formik.errors.email}</Typography>
                  )}
                </Box>
              )} */}
              {/* <Typography className={styles.messageRateLabel}>{AuthFormStrings.WellSentYouCode}</Typography> */}
              <AuthSubmitBtn
                sx={{
                  height: '48px',
                  borderRadius: '12px',
                }}
                variant="contained"
                fullWidth
                disabled={sendVerificationCodeBtnDisabled}
                type="submit"
              >
                {`Here's My Info!`}
              </AuthSubmitBtn>
              {/* <Typography className={styles.messageRateText} color={'#767676'}>
            {AuthFormStrings.MessageRate}
          </Typography> */}
            </StyledForm>
          </PortalWrapper>
        )}
        {isVerificationComplete && <Box></Box>}
        <CaptchaWrapper display={'block'}>
          <ReCaptcha
            onChange={onCaptchaChange}
            key="captcha"
            ref={ecaptchaRef}
            onError={() => {
              setIsEnterpriseCaptcha(false);
            }}
            onExpired={() => {
              setIsEnterpriseCaptcha(false);
            }}
            isEnterprise={isEnterpriseCaptcha}
            onClick={() => {
              trackEvent({ action: EventNames.Captcha_Checkbox_Click, accountId });
            }}
          />
        </CaptchaWrapper>
      </StyledContainer>
    </Box>
  );
};

export default VerificationScreen;
